import store_laboratoire from '@/store/mods/analyses/laboratoire'
import { date_heure, mois_courant, registre_impression } from '@/utils/laboratoire-delais'

// LAB-008 : registre des non-conformités — rejets d'échantillons et non-conformités déclarées, par mois, imprimable.
export const CATEGORIES_DEFAUT = [
    { id: 'identification', libelle: 'Identification du patient ou de l\'échantillon' },
    { id: 'prelevement', libelle: 'Prélèvement (volume, contenant, conditions)' },
    { id: 'transport', libelle: 'Transport ou conservation' },
    { id: 'delai', libelle: 'Délai dépassé' },
    { id: 'equipement', libelle: 'Équipement ou réactif' },
    { id: 'procedure', libelle: 'Procédure non respectée' },
    { id: 'resultat', libelle: 'Résultat ou compte rendu' },
    { id: 'autre', libelle: 'Autre' }
]

const message = (error, fallback) => error && error.response && error.response.data && typeof error.response.data.message === 'string' ? error.response.data.message : fallback

function formulaire_vide() {
    return { reference: '', categorie: '', commentaire: '', action: '' }
}

export default {
    name: 'registre-non-conformites',
    components: {},
    props: [],
    data() {
        return {
            mois: mois_courant(), page: 1, pages: 1, total: 0,
            lignes: [], compteurs: null, is_loading: false, erreur: '', info: '', sequence: 0, detruit: false,
            categories: CATEGORIES_DEFAUT,
            modal: false, form: formulaire_vide(), is_saving: false, erreur_modal: '',
            modal_cloture: false, ligne_cloture: null, verification_cloture: '', erreur_cloture: '',
            apercu: false
        }
    },

    watch: {

    },

    computed: {
        html_impression() {
            const info = (this.info_clinique && typeof this.info_clinique === 'object') ? this.info_clinique : {}
            return registre_impression(this.mois, this.lignes, { nom: info.nom || '', fuseau_horaire: info.fuseau_horaire || 'UTC' })
        }
    },

    mounted() {
        this.charger()
        this.charger_referentiel()
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
    },

    methods: {
        charger() {
            if (this.detruit) return Promise.resolve()
            const sequence = ++this.sequence
            this.is_loading = true
            this.erreur = ''
            return store_laboratoire.getNonConformites({ mois: this.mois, page: this.page }).then((result) => {
                if (this.detruit || sequence !== this.sequence) return
                if (!result || !Array.isArray(result.data) || !result.counts) throw new Error('Réponse invalide')
                this.lignes = result.data
                this.compteurs = result.counts
                this.total = result.total
                this.pages = Math.max(1, result.last_page)
                this.is_loading = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.sequence) return
                this.lignes = []
                this.compteurs = null
                this.total = 0
                this.is_loading = false
                this.erreur = message(error, 'Impossible de charger le registre. Réessayez avec Actualiser.')
            })
        },

        // Catégories du référentiel de la Clinique (repli local sinon)
        charger_referentiel() {
            return store_laboratoire.getReferentiel().then((response) => {
                if (response && response.success && response.data && response.data.motifs_non_conformite) {
                    const categories = []
                    Object.keys(response.data.motifs_non_conformite).forEach((id) => { categories.push({ id: id, libelle: response.data.motifs_non_conformite[id] }) })
                    if (categories.length) this.categories = categories
                }
            }).catch(() => {
                this.categories = CATEGORIES_DEFAUT
            })
        },

        changer_mois() {
            this.page = 1
            this.apercu = false
            return this.charger()
        },

        aller_page(page) {
            if (page >= 1 && page <= this.pages) { this.page = page; this.charger() }
        },

        ouvrir_declaration() {
            this.form = formulaire_vide()
            this.erreur_modal = ''
            this.modal = true
        },

        valider() {
            if (!this.form.categorie) return 'Choisissez la catégorie de la non-conformité.'
            if (!this.form.commentaire.trim()) return 'Décrivez la non-conformité constatée.'
            return ''
        },

        declarer() {
            if (this.is_saving) return Promise.resolve()
            const erreur = this.valider()
            if (erreur) {
                this.erreur_modal = erreur
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur_modal = ''
            const texte = valeur => (valeur && String(valeur).trim()) ? String(valeur).trim() : null
            return store_laboratoire.declarerNonConformite({ categorie: this.form.categorie, commentaire: this.form.commentaire.trim(), action: texte(this.form.action), reference: texte(this.form.reference) }).then((response) => {
                if (this.detruit) return
                if (!response || response.success !== true) throw new Error('Déclaration refusée')
                this.info = response.message || 'Non-conformité enregistrée au registre.'
                this.modal = false
                this.is_saving = false
                this.page = 1
                return this.charger()
            }).catch((error) => {
                if (this.detruit) return
                this.is_saving = false
                this.erreur_modal = message(error, 'La non-conformité n\'a pas été enregistrée. Réessayez.')
            })
        },

        ouvrir_cloture(ligne) {
            this.ligne_cloture = ligne
            this.verification_cloture = ''
            this.erreur_cloture = ''
            this.modal_cloture = true
        },

        cloturer() {
            if (this.is_saving || !this.ligne_cloture) return Promise.resolve()
            const verification = this.verification_cloture.trim()
            if (!verification) {
                this.erreur_cloture = 'Décrivez la vérification de clôture.'
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur_cloture = ''
            return store_laboratoire.cloturerNonConformite(this.ligne_cloture.id, { verification: verification }).then((response) => {
                if (!response || response.success !== true) throw new Error('Clôture refusée')
                this.info = response.message || 'Non-conformité clôturée après vérification.'
                this.modal_cloture = false
                this.is_saving = false
                return this.charger()
            }).catch((error) => {
                if (this.detruit) return
                this.is_saving = false
                this.erreur_cloture = message(error, 'La non-conformité n\'a pas été clôturée. Réessayez.')
            })
        },

        imprimer() {
            const cadre = this.$refs.impression
            if (!cadre || !cadre.contentWindow) return
            cadre.contentWindow.focus()
            cadre.contentWindow.print()
        },

        date_heure(value) {
            return date_heure(value) || 'Non renseignée'
        }
    }
}
